import { getSession, useGetAllProfileQuery } from '@onesource/services';
type TAuthProviderProps = {
  children: JSX.Element | JSX.Element[];
};

export const ProfileInfoProvider = (params: TAuthProviderProps) => {
  const { children } = params;
  const token = getSession();

  useGetAllProfileQuery({ token });

  return children;
};
